﻿import * as layerTypes from '../../../map/utils/layerTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import * as eventTypes from '../../../map/utils/eventTypes';
import Draw from 'ol/interaction/Draw';
import * as styleTypes from '../../../map/utils/style/styleTypes';
import {
    Fill,
    Stroke,
    Style,
    Text,
} from 'ol/style.js';
import { LineString, Point, GeometryCollection } from 'ol/geom.js';
import { measureLength } from '../../../map/utils/utils';
import { primaryAction } from 'ol/events/condition';

export default class DimensioningControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, toolbarContainer, snapOpts) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.toolbarContainer = toolbarContainer;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.simpleDimensioningId = 'simple-dimensioning-' + this.classId;
        this.radialDimensioningId = 'radial-dimensioning-' + this.classId;
        this.orthogonalDimensioningId = 'orthogonal-dimensioning-' + this.classId;
        this.freeDimensioningId = 'free-dimensioning-' + this.classId;
        this.deleteDimensioningId = 'delete-dimensioning-' + this.classId;
        this.deleteAllDimensioningsId = 'delete-all-dimensionings-' + this.classId;
        this.uomId = 'uom-id-' + this.classId;
        this.prefixId = 'prefix-id-' + this.classId;
        this.suffixId = 'suffix-id-' + this.classId;
        this.precisionId = 'precisionId-id-' + this.classId;
        this.active = false;
        this.layerAdded = false;
        this.currentInteractionType = null;
        this.currentInteractionFeature = null;
        this._handleClickOnMapForOrthogonal = this._handleClickOnMapForOrthogonal.bind(this);
        this._handleClickOnMapForFree = this._handleClickOnMapForFree.bind(this);
        this.deleteEnabled = false;
        this.currentId = 1;
        this.keydownEvent = (evt) => {
            if (evt.keyCode == 27) {
                this._stopDraw();
            }
        };
        this._initStandardStyle();
        this._initStandardSelectStyle();
        this._initDrawStyle();
    }

    init() {
        if ($('.map-serach-config').length > 0) {
            $('.map-serach-config').addClass('map-search-joined');
        }

        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        $event.register(eventTypes.USER_INTERACTION_STARTED, this._getUserInteractionStartedHandler(), this, this.classId);
        $event.register(eventTypes.MAP_POINTER_MOVE, this._getUserMapPointerMoveHandler(), this, this.classId);
        $event.register(eventTypes.MAP_POINTER_CLICK, this._getUserMapPointerClickHandler(), this, this.classId);
        $event.register(eventTypes.RIGHT_CLICK, this._getUserMapRightClickHandler(), this, this.classId);
    }

    _stopDraw() {
        if (this.currentInteraction != null) {
            this.currentInteraction.abortDrawing();
            data.originalEvent.preventDefault();
            this.currentInteractionSuspended = true;
            this._removeInteraction();

            if (this.currentInteractionFeature != null) {
                this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(this.currentInteractionFeature);
                this._stopOrthogonalFlow();
                this._stopFreeFlow();
            }

            if ($('.feature-toolbar-button.active').length > 0) {
                let item = $($('.feature-toolbar-button.active')[0]);
                item.removeClass('active');
                item.click();
            }
        } else if (this.currentInteractionFeature != null) {
            this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(this.currentInteractionFeature);
            this._stopOrthogonalFlow();
            this._stopFreeFlow();
            $('#' + this.mapControl.mapElementId).off('click', this._handleClickOnMapForOrthogonal);
            $('#' + this.mapControl.mapElementId).off('click', this._handleClickOnMapForFree);

            if ($('.feature-toolbar-button.active').length > 0) {
                let item = $($('.feature-toolbar-button.active')[0]);
                item.removeClass('active');
                item.click();
            }
        }
    }

    _getUserMapRightClickHandler() {
        var handler = (eventName, data, sender) => {
            this._stopDraw();
        };

        return handler;
    }

    _getUserMapPointerMoveHandler() {
        var handler = (eventName, data, sender) => {
            if (this.deleteEnabled) {
                if (data.originalEvent == null) {
                    return;
                }

                let pixel = this.mapControl.map.getEventPixel(data.originalEvent);

                if (pixel == null) {
                    return;
                }

                let options = {
                    layerFilter: (layer) => {
                        return layer.get("uid") == layerTypes.DIMENSIONING;
                    }
                }

                var features = this.mapControl.map.getFeaturesAtPixel(pixel, options);

                if (features.length > 0) {
                    this.mapControl.map.getViewport().style.cursor = 'pointer';
                } else {
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }
            }
        };

        return handler;
    }

    _getUserMapPointerClickHandler() {
        var handler = (eventName, data, sender) => {
            if (this.deleteEnabled) {
                if (data.originalEvent == null) {
                    return;
                }

                let pixel = this.mapControl.map.getEventPixel(data.originalEvent);

                if (pixel == null) {
                    return;
                }

                let options = {
                    layerFilter: (layer) => {
                        return layer.get("uid") == layerTypes.DIMENSIONING;
                    }
                }

                var features = this.mapControl.map.getFeaturesAtPixel(pixel, options);

                if (features.length > 0) {
                    this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(features[0]);
                }
            }
        };

        return handler;
    }

    _initStandardStyle() {
        this.measureStyle = new Style({
            fill: new Fill({
                color: 'rgba(106,90,205, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(106,90,205, 1)',
                width: 2,
            })
        });

        this.labelStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(106,90,205, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });

        this.segmentStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(106,90,205, 1)',
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                }),
                overflow: 'true',
                maxAngle: 360,
                placement: 'line',
                offsetY: -10,
            })
        });

        this.arrowStyle = new Style({
            text: new Text({
                text: '>',  // Unicode for a rightwards arrow (→)
                font: '22px Arial',
                fill: new Fill({
                    color: 'rgba(106,90,205, 1)'
                }),
                offsetY: 2,
                offsetX: -3
            })
        });
    }

    _initStandardSelectStyle() {
        this.measureSelectStyle = new Style({
            fill: new Fill({
                color: 'rgba(0, 255, 12, 0.3)',
            }),
            stroke: new Stroke({
                color: 'rgba(0, 255, 12, 1)',
                width: 2,
            })
        });

        this.labelSelectStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 255, 12, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });

        this.segmentSelectStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 255, 12, 1)',
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                }),
                overflow: 'true',
                maxAngle: 360,
                placement: 'line',
                offsetY: -10,
            })
        });

        this.arrowSelectStyle = new Style({
            text: new Text({
                text: '>',  // Unicode for a rightwards arrow (→)
                font: '22px Arial',
                fill: new Fill({
                    color: 'rgba(0, 255, 12, 1)'
                }),
                offsetY: 2,
                offsetX: -3
            })
        });
    }

    _initDrawStyle() {
        this.drawMeasureStyle = new Style({
            fill: new Fill({
                color: 'rgba(255, 0, 0, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 2,
            })
        });

        this.drawLabelStyle = new Style({
            text: new Text({
                font: 'bold 16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._removeInteraction();
                this._hideToolbar();
            } else {
                $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
                this._showToolbar();
            }
        };
    }

    _getUserInteractionStartedHandler() {
        var handler = (eventName, data, sender) => {
            this._removeInteraction();
            this._hideToolbar();
        };

        return handler;
    }

    _hideToolbar() {
        this.active = false;
        this.toolbarContainer.innerHTML = '';
        this.mapControl.selectionHandler.isActive = true;
        document.removeEventListener('keydown', this.keydownEvent);
        $event.notify(eventTypes.DRAW_TOOLBAR_HIDDEN, {}, this, this.classId);
        $('#' + this.elementId).removeClass('selected');
    }

    _showToolbar() {
        $('#' + this.elementId).addClass('selected');
        if (!this.layerAdded) {
            this._addDimensioningLayer();
        }

        this.active = true;
        this.toolbarContainer.innerHTML = this._getToolbarTemplate();
        this.mapControl.map.getViewport().style.cursor = 'inherit';

        $('.feature-toolbar-extra-content').css('width', $('.header-options').width() + 'px');

        let uoms = this._getUom();

        $('#' + this.uomId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: uoms,
            change: (evt) => {
                let val = evt.sender.value();

                $('#' + this.suffixId).val(val != null ? val.toLowerCase() : 'n/a');
            }
        });

        $('#' + this.precisionId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.precisionId).data('kendoNumericTextBox').value(3);

        $('#' + this.uomId).data('kendoComboBox').value(uoms[1].id);
        $('#' + this.suffixId).val(uoms[1].id.toLowerCase());

        $('#' + this.simpleDimensioningId).on('click', () => {
            this._simpleDimensioning();
        });

        $('#' + this.radialDimensioningId).on('click', () => {
            this._radialDimensioning();
        });

        $('#' + this.orthogonalDimensioningId).on('click', () => {
            this._orthogonalDimensioning();
        });

        $('#' + this.freeDimensioningId).on('click', () => {
            this._freeDimensioning();
        });

        $('#' + this.deleteDimensioningId).on('click', () => {
            this._deleteDimensioning();
        });

        $('#' + this.deleteAllDimensioningsId).on('click', () => {
            this._deleteAllDimensionings();
        });

        document.addEventListener('keydown', this.keydownEvent);
        $event.notify(eventTypes.DRAW_TOOLBAR_VISIBLE, {}, this, this.classId);
    }

    _deleteDimensioning() {

        if ($('#' + this.deleteDimensioningId).hasClass('active')) {
            $('#' + this.deleteDimensioningId).removeClass('active');
            this.deleteEnabled = false;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.deleteDimensioningId).addClass('active');
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this._removeInteraction();
            this.deleteEnabled = true;
        }
    }

    _deleteAllDimensionings() {
        this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().clear();
    }

    _simpleDimensioning() {
        if ($('#' + this.simpleDimensioningId).hasClass('active')) {
            $('#' + this.simpleDimensioningId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.simpleDimensioningId).addClass('active');
            this._startSimpleDimensioning();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _radialDimensioning() {
        if ($('#' + this.radialDimensioningId).hasClass('active')) {
            $('#' + this.radialDimensioningId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.radialDimensioningId).addClass('active');
            this._startRadialDimensioning();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _orthogonalDimensioning() {
        if ($('#' + this.orthogonalDimensioningId).hasClass('active')) {
            $('#' + this.orthogonalDimensioningId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.orthogonalDimensioningId).addClass('active');
            this._startOrthogonalDimensioning();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _freeDimensioning() {
        if ($('#' + this.freeDimensioningId).hasClass('active')) {
            $('#' + this.freeDimensioningId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.freeDimensioningId).addClass('active');
            this._startFreeDimensioning();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _startSimpleDimensioning() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource(),
            type: 'LineString',
            maxPoints: 2,
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('labelPrefix', $('#' + this.prefixId).val());
                evt.feature.set('labelSuffix', $('#' + this.suffixId).val());
                evt.feature.set('labelPrecision', $('#' + this.precisionId).data('kendoNumericTextBox').value());
                evt.feature.set('isIntermediary', false);
                evt.feature.set('drawType', 'SimpleDimensioning');
                evt.feature.layerId = layerTypes.DIMENSIONING;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _startRadialDimensioning() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource(),
            type: 'LineString',
            maxPoints: 2,
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('labelPrefix', $('#' + this.prefixId).val());
                evt.feature.set('labelSuffix', $('#' + this.suffixId).val());
                evt.feature.set('labelPrecision', $('#' + this.precisionId).data('kendoNumericTextBox').value());
                evt.feature.set('isIntermediary', false);
                evt.feature.set('drawType', 'RadialDimensioning');
                evt.feature.layerId = layerTypes.DIMENSIONING;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _startOrthogonalDimensioning() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource(),
            type: 'LineString',
            maxPoints: 2,
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('labelPrefix', $('#' + this.prefixId).val());
                evt.feature.set('labelSuffix', $('#' + this.suffixId).val());
                evt.feature.set('labelPrecision', $('#' + this.precisionId).data('kendoNumericTextBox').value());
                evt.feature.set('isIntermediary', true);
                evt.feature.set('drawType', 'OrthogonalDimensioning');
                evt.feature.layerId = layerTypes.DIMENSIONING;
                evt.feature.set('id', this.currentId);
                this.currentId++;
                this.currentInteractionType = 'OrthogonalDimensioning';
                this.currentInteractionFeature = evt.feature;
                this._startOrthogonalFlow(evt.feature);
                this._removeInteraction();
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _startFreeDimensioning() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource(),
            type: 'LineString',
            maxPoints: 2,
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('labelPrefix', $('#' + this.prefixId).val());
                evt.feature.set('labelSuffix', $('#' + this.suffixId).val());
                evt.feature.set('labelPrecision', $('#' + this.precisionId).data('kendoNumericTextBox').value());
                evt.feature.set('isIntermediary', true);
                evt.feature.set('drawType', 'FreeDimensioning');
                evt.feature.layerId = layerTypes.DIMENSIONING;
                evt.feature.set('id', this.currentId);
                this.currentId++;
                this.currentInteractionType = 'FreeDimensioning';
                this.currentInteractionFeature = evt.feature;
                this._startFreeFlow(evt.feature);
                this._removeInteraction();
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _startOrthogonalFlow() {
        $event.register(eventTypes.MAP_POINTER_MOVE, this._getMapPointerMoveHandlerForOrthogonal, this, this.classId);
        setTimeout(() => {
            $('#' + this.mapControl.mapElementId).on('click', this._handleClickOnMapForOrthogonal);
        }, 10);
    }

    _startFreeFlow() {
        $event.register(eventTypes.MAP_POINTER_MOVE, this._getMapPointerMoveHandlerForFree, this, this.classId);
        setTimeout(() => {
            $('#' + this.mapControl.mapElementId).on('click', this._handleClickOnMapForFree);
        }, 10);
    }

    _handleClickOnMapForOrthogonal(evt) {
        if (evt.button == 0) {
            this._stopOrthogonalFlow();
            this.currentInteractionFeature.set('isIntermediary', false);
            this.currentInteractionType = null;
            this.currentInteractionFeature = null;
            $('#' + this.mapControl.mapElementId).off('click', this._handleClickOnMapForOrthogonal);
            this._startOrthogonalDimensioning();
        }
    }

    _handleClickOnMapForFree(evt) {
        if (evt.button == 0) {
            this._stopFreeFlow();
            this.currentInteractionFeature.set('isIntermediary', false);
            this.currentInteractionType = null;
            this.currentInteractionFeature = null;
            $('#' + this.mapControl.mapElementId).off('click', this._handleClickOnMapForFree);
            this._startFreeDimensioning();
        }
    }

    _stopOrthogonalFlow() {
        $event.unregister(eventTypes.MAP_POINTER_MOVE, this._getMapPointerMoveHandler, this, this.classId);
    }

    _stopFreeFlow() {
        $event.unregister(eventTypes.MAP_POINTER_MOVE, this._getMapPointerMoveHandler, this, this.classId);
    }

    _getMapPointerMoveHandlerForOrthogonal(eventName, data, sender) {
        let pixel = data.pixel;
        let coordinate = this.mapControl.map.getCoordinateFromPixel(pixel);
        if (this.currentInteractionType == 'OrthogonalDimensioning') {
            this._handleOrthogonalFlow(coordinate);
        }
    }

    _getMapPointerMoveHandlerForFree(eventName, data, sender) {
        let pixel = data.pixel;
        let coordinate = this.mapControl.map.getCoordinateFromPixel(pixel);
        if (this.currentInteractionType == 'FreeDimensioning') {
            this._handleFreeFlow(coordinate);
        }
    }

    _handleOrthogonalFlow(coordinate) {
        if (this.currentInteractionFeature.getGeometry().getType() == 'LineString') {
            let initial = this.currentInteractionFeature.getGeometry();
            initial.set('customType', 'initial');
            let multiGeometry = new GeometryCollection([initial]);
            this.currentInteractionFeature.setGeometry(multiGeometry);
        }

        let initial = this.currentInteractionFeature.getGeometry().getGeometries().find(x => { return x.get('customType') == 'initial' });
        
        let parallelLine = this._createOrthogonalParallelLine(initial.getCoordinates(), coordinate, 0);
        parallelLine.set('customType', 'parallel');

        let initialStart = initial.getCoordinates()[0];
        let initialEnd = initial.getCoordinates()[1];
        let parallelStart = parallelLine.getCoordinates()[0];
        let parallelEnd = parallelLine.getCoordinates()[1];

        let firstPerpendicular = new LineString([initialStart, parallelStart]);
        firstPerpendicular.set('customType', 'perpendicular');
        let secondPerpendicular = new LineString([initialEnd, parallelEnd]);
        secondPerpendicular.set('customType', 'perpendicular');

        let resultingGeometry = new GeometryCollection([initial, parallelLine, firstPerpendicular, secondPerpendicular]);
        this.currentInteractionFeature.setGeometry(resultingGeometry);
    }

    _handleFreeFlow(coordinate) {
        if (this.currentInteractionFeature.getGeometry().getType() == 'LineString') {
            let initial = this.currentInteractionFeature.getGeometry();
            initial.set('customType', 'initial');
            let multiGeometry = new GeometryCollection([initial]);
            this.currentInteractionFeature.setGeometry(multiGeometry);
        }

        let initial = this.currentInteractionFeature.getGeometry().getGeometries().find(x => { return x.get('customType') == 'initial' });

        let parallelLine = this._createSimpleParallelLine(initial.getCoordinates(), coordinate);
        parallelLine.set('customType', 'parallel');

        let initialStart = initial.getCoordinates()[0];
        let initialEnd = initial.getCoordinates()[1];
        let parallelStart = parallelLine.getCoordinates()[0];
        let parallelEnd = parallelLine.getCoordinates()[1];

        let firstPerpendicular = new LineString([initialStart, parallelStart]);
        firstPerpendicular.set('customType', 'perpendicular');
        let secondPerpendicular = new LineString([initialEnd, parallelEnd]);
        secondPerpendicular.set('customType', 'perpendicular');

        let resultingGeometry = new GeometryCollection([initial, parallelLine, firstPerpendicular, secondPerpendicular]);
        this.currentInteractionFeature.setGeometry(resultingGeometry);
    }

    _createOrthogonalParallelLine(lineCoordinates, pointCoordinates) {
        const start = lineCoordinates[0];
        const end = lineCoordinates[1];

        const dx = end[0] - start[0];
        const dy = end[1] - start[1];

        const perpDx = -dy;
        const perpDy = dx;

        const length = Math.sqrt(perpDx * perpDx + perpDy * perpDy);
        const unitPerpDx = perpDx / length;
        const unitPerpDy = perpDy / length;

        const offset = this._perpendicularDistance(pointCoordinates, start, end);

        const crossProduct = (pointCoordinates[0] - start[0]) * (end[1] - start[1]) - (pointCoordinates[1] - start[1]) * (end[0] - start[0]);

        const finalOffset = crossProduct < 0 ? -offset : offset;

        const parallelStart = [
            start[0] + unitPerpDx * finalOffset,
            start[1] + unitPerpDy * finalOffset
        ];

        const parallelEnd = [
            parallelStart[0] + dx,
            parallelStart[1] + dy
        ];

        return new LineString([parallelStart, parallelEnd]);
    }

    _perpendicularDistance(point, lineStart, lineEnd) {
        const x1 = lineStart[0], y1 = lineStart[1];
        const x2 = lineEnd[0], y2 = lineEnd[1];
        const x0 = point[0], y0 = point[1];

        // Line equation coefficients: Ax + By + C = 0
        const A = y2 - y1;
        const B = x1 - x2;
        const C = x2 * y1 - x1 * y2;

        // Perpendicular distance formula
        const dist = Math.abs(A * x0 + B * y0 + C) / Math.sqrt(A * A + B * B);
        return dist * -1;
    }

    _createSimpleParallelLine(lineCoordinates, pointCoordinates) {
        const start = lineCoordinates[0];
        const end = lineCoordinates[1];

        const dx = end[0] - start[0];
        const dy = end[1] - start[1];

        const length = Math.sqrt(dx * dx + dy * dy);
        const unitDx = dx / length;
        const unitDy = dy / length;

        const offsetX = pointCoordinates[0] - start[0];
        const offsetY = pointCoordinates[1] - start[1];

        const parallelStart = [start[0] + offsetX, start[1] + offsetY];
        const parallelEnd = [end[0] + offsetX, end[1] + offsetY];

        return new LineString([parallelStart, parallelEnd]);
    }

    _drawStyleFunction(feature, drawType) {
        let styles = [];
        let geometry = feature.getGeometry();
        let type = geometry.getType();
        let point, label, pointLabel;
        if (!drawType || drawType === type) {
            styles.push(new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 5,
                })
            }));

            styles.push(this.drawMeasureStyle.clone());

            if (type === 'LineString') {
                point = new Point(geometry.getLastCoordinate());
                label = this._formatLength(feature, this._measureLength(geometry));
                pointLabel = this._formatCoordinates(feature, point);
            } else if (drawType == 'Point' || (type == 'Point' && drawType != 'Point')) {
                point = new Point(geometry.getCoordinates());
                label = this._formatCoordinates(feature, geometry);
            }
        }

        if (label) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(label);

            if (pointLabel) {
                clone.getText().setOffsetY(27);
            }

            styles.push(clone);
        }

        if (pointLabel) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(pointLabel);

            styles.push(clone);
        }

        return styles;
    }

    _styleFunction(feature, drawType, isIntermediary) {
        if (isIntermediary) {
            let styles = [];

            if (feature.getGeometry().getType() == 'GeometryCollection') {
                let geometries = feature.getGeometry().getGeometries();

                geometries.forEach(geometry => {
                    if (geometry.get('customType') != 'initial') {
                        let style = this.drawMeasureStyle.clone();

                        style.setGeometry(new GeometryCollection([geometry]));

                        styles.push(style);
                    }
                });
            }
            return styles;
        } else {
            let styles = [];
            let geometry = feature.getGeometry();
            let isSelected = feature.get('xstate') == styleTypes.SELECT_STYLE_TYPE || feature.get('xstate') == styleTypes.HOVER_STYLE_TYPE;

            if (feature.get('drawType') == 'OrthogonalDimensioning' || feature.get('drawType') == 'FreeDimensioning') {
                let geometries = geometry.getGeometries();

                geometries.forEach(geom => {
                    if (geom.get('customType') != 'initial') {
                        if (geom.get('customType') == 'parallel') {
                            let style = isSelected ? this.measureSelectStyle.clone() : this.measureStyle.clone();

                            style.setGeometry(new GeometryCollection([geom]));
                            styles.push(style);

                            let label = this._formatLength(feature, this._measureLength(geom));
                            let segmentDistance = isSelected ? this.segmentSelectStyle.clone() : this.segmentStyle.clone();
                            segmentDistance.setGeometry(geom);
                            segmentDistance.getText().setText(label);

                            styles.push(segmentDistance);

                            let startArrowStyle = isSelected ? this.arrowSelectStyle.clone() : this.arrowStyle.clone();
                            startArrowStyle.setGeometry(new Point(geom.getFirstCoordinate()));
                            startArrowStyle.getText().setRotation(this._degreesToRadians(this._getRotation(geom) + 90));
                            styles.push(startArrowStyle);

                            let endArrowStyle = isSelected ? this.arrowSelectStyle.clone() : this.arrowStyle.clone();
                            endArrowStyle.setGeometry(new Point(geom.getLastCoordinate()));
                            endArrowStyle.getText().setRotation(this._degreesToRadians(this._getRotation(geom) - 90));
                            styles.push(endArrowStyle);
                        } else {
                            let style = isSelected ? this.measureSelectStyle.clone() : this.measureStyle.clone();

                            style.setGeometry(new GeometryCollection([geom]));

                            styles.push(style);
                        }
                    }
                });
            } else {
                styles.push(isSelected ? this.measureSelectStyle.clone() : this.measureStyle.clone());

                let label = this._formatLength(feature, this._measureLength(geometry));
                let segmentDistance = isSelected ? this.segmentSelectStyle.clone() : this.segmentStyle.clone();
                segmentDistance.setGeometry(geometry);
                segmentDistance.getText().setText(label);

                styles.push(segmentDistance);

                if (drawType == 'SimpleDimensioning') {
                    let startArrowStyle = isSelected ? this.arrowSelectStyle.clone() : this.arrowStyle.clone();
                    startArrowStyle.setGeometry(new Point(geometry.getFirstCoordinate()));
                    startArrowStyle.getText().setRotation(this._degreesToRadians(this._getRotation(geometry) + 90));
                    styles.push(startArrowStyle);
                }

                let endArrowStyle = isSelected ? this.arrowSelectStyle.clone() : this.arrowStyle.clone();
                endArrowStyle.setGeometry(new Point(geometry.getLastCoordinate()));
                endArrowStyle.getText().setRotation(this._degreesToRadians(this._getRotation(geometry) - 90));
                styles.push(endArrowStyle);
            }

            return styles;
        }
    }

    _degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    }

    _getRotation(geometry) {
        let coords = geometry.getCoordinates();

        let first = coords[0];
        let last = coords[1];
        let rotation = -Math.atan2((last[1] - first[1]), (last[0] - first[0]));
        rotation = rotation * (180 / Math.PI);

        if (rotation < 0) {
            rotation = 360 + rotation;
        }

        rotation += 90;

        if (rotation > 360) {
            rotation -= 360;
        }

        return rotation;
    }

    _formatCoordinates(feature, geometry) {
        let coordinates = geometry.getCoordinates();
        return Math.round(coordinates[0] * 1000) / 1000 + ' \n ' + Math.round(coordinates[1] * 1000) / 1000;
    }

    //CG: masuram in proiectia curenta a hartii, nu in Web Mercator implicit din ol/sphere
    _measureLength(geometry) {
        return measureLength(geometry, this.mapControl.map.getView().getProjection());
    }

    _formatLength(feature, length) {
        let output;

        let uom;

        if (feature.get('labelUnits') != null) {
            uom = feature.get('labelUnits');
        } else {
            uom = $('#' + this.uomId).data('kendoComboBox').value();
        }

        let prefix = feature.get('labelPrefix');

        if (prefix == null) {
            prefix = $('#' + this.prefixId).val();
        }

        let suffix = feature.get('labelSuffix');

        if (suffix == null) {
            suffix = $('#' + this.suffixId).val();
        }

        let precision = feature.get('labelPrecision');

        if (precision == null) {
            precision = $('#' + this.precisionId).data('kendoNumericTextBox').value();
        }

        let val;
        switch (uom) {
            case 'CM': val = length * 100;
                break;
            case 'M': val = length;
                break;
            case 'KM': val = Math.round((length / 1000) * 100) / 100;
                break;
        }

        let precisionMultiplier = this._precisitionToNumber(precision);
        val = Math.round(val * precisionMultiplier) / precisionMultiplier;

        return prefix + ' ' + val + ' ' + suffix;
    }

    _precisitionToNumber(precision) {
        if (precision == null) {
            precision = 0;
        }

        let result = 1;

        for (let i = 0; i < precision; i++) {
            result = result * 10;
        }

        return result;
    }

    _getUom() {
        let viewUnits = this.mapControl.map.getView().getProjection().getUnits();

        if (viewUnits == 'm') {
            return [
                {
                    id: 'CM',
                    name: this.resourcesHandler.get('CM')
                }, {
                    id: 'M',
                    name: this.resourcesHandler.get('M')
                }, {
                    id: 'KM',
                    name: this.resourcesHandler.get('KM')
                }
            ];
        }
    }

    _removeInteraction() {
        if (this.currentInteraction != null) {
            this.mapControl.map.removeInteraction(this.currentInteraction);
            this.currentInteraction = null;
        }

        $event.notify(eventTypes.STOP_SNAP, {}, this, this.mapControl.classId);
        this.deleteEnabled = false;
    }

    _addDimensioningLayer() {
        this.layerAdded = true;
        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.DIMENSIONING,
            geometryType: geomTypes.GEOM_ALL,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            visible: true,
            displayName: this.resourcesHandler.get('DimensioningResults'),
            ignoreStyle: true,
            addToLegend: true,
            parentId: layerTypes.INTERACTION_TOOLS,
            parentDisplayName: this.resourcesHandler.get('UserInteractionResults'),
            showLegend: false,
            declutter: false,
            selectable: true
        }).then(() => {
            let layer = this.mapControl.layerHandler.getLayerById(layerTypes.DIMENSIONING)[0];
            layer.setStyle((feature) => {
                return this._styleFunction(feature, feature.get('drawType'), feature.get('isIntermediary'));
            });
        });
    }

    _getToolbarTemplate() {
        return `<div class="feature-toolbar-content">
                    <div title="` + this.resourcesHandler.get('SimpleDimensioning') + `" class="feature-toolbar-button icon xp-icon-simple-dim" id="` + this.simpleDimensioningId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RadialDimensioning') + `" class="feature-toolbar-button icon xp-icon-radial-dim" id="` + this.radialDimensioningId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('OrthogonalDimensioning') + `" class="feature-toolbar-button icon xp-icon-ortho-dim" id="` + this.orthogonalDimensioningId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('FreeDimensioning') + `" class="feature-toolbar-button icon xp-icon-free-dim" id="` + this.freeDimensioningId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RemoveDimensioning') + `" class="feature-toolbar-button fal fa-comment-times" id="` + this.deleteDimensioningId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RemoveAllDimensionings') + `" class="feature-toolbar-button fal fa-trash-alt" id="` + this.deleteAllDimensioningsId + `">
                    </div>
                </div>
                <div class="feature-toolbar-extra-content">
                    <div class="col-12 mb-2 mt-3">
                        <div class="form-group d-flex">
                            <div class="col-4 align-content-center pl-0">
                                <label>` + this.resourcesHandler.get('UOM') + `:</label>
                            </div>
                            <div class="col-8 pr-0">
                                <input class="form-control" id="` + this.uomId + `">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-2">
                        <div class="form-group d-flex">
                            <div class="col-4 align-content-center pl-0">
                                <label class="form-label">` + this.resourcesHandler.get('Prefix') + `:</label>
                            </div>
                            <div class="col-8 pr-0">
                                <input class="form-control" id="` + this.prefixId + `" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-2">
                        <div class="form-group d-flex">
                            <div class="col-4 align-content-center pl-0">
                                <label class="form-label">` + this.resourcesHandler.get('Suffix') + `:</label>
                            </div>
                            <div class="col-8 pr-0">
                                <input class="form-control" id="` + this.suffixId + `" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="form-group d-flex">
                            <div class="col-4 align-content-center pl-0">
                                <label class="form-label">` + this.resourcesHandler.get('Precision') + `:</label>
                            </div>
                            <div class="col-8 pr-0">
                                <input class="form-control" id="` + this.precisionId + `" type="text">
                            </div>
                        </div>
                    </div>
                </div>`;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}